<template>
    <div
        :class="[
            'o-start-items-dropdown',
            (isSelectOpen && 'o-start-items-dropdown--open')
        ]"
    >
        <slot>
            <ODropdownOtg
                :value="startObjectId"
                :items="startItems"
                :disabled="isStartLocked"
                :label="$t('ui.start-2')"
                :placeholder="placeholder"
                :filterable="filterable"
                :clearable="clearable"
                :isShowLabel="isShowLabel"
                class="path-settings-dropdown"
                @input="onChangeStart"
                @onOpenChange="onOpenChange"
                ref="oDropdown"
            />
        </slot>
    </div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import uniqBy from 'lodash/uniqBy'
import cloneDeep from 'lodash/cloneDeep'

import ODropdownOtg from '../o-dropdown-otg';

import {
    DESTINATION_NAMES,
} from "./path-settings-service";

export default {
    name: 'OStartItemsDropdown',
    props: {
        isShowLabel: {
            type: Boolean,
            default: true
        },
        dropdownType: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    components: {
        ODropdownOtg
    },
    data() {
        return {
            isSelectOpen: false
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getTenantsAZ',
            'getMyPosition',
            'getEntrancesAZ',
            'getMapConfigProp',
            'getServicesObjectsAZ',
            'getPortalsForCatalogueAZ',
            'getDenormalisedObjectById',
            'getObjectClosestEntranceId',
        ]),
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        },
        startObjectIdFromQuery(){
            return this.$route.query.mFrom;
        },
        startObjectId(){
            return this.startObject?.id;
        },
        isStartLocked(){
            return Boolean(this.$route.query.mFromLocked);
        },
        filterable() {
            return this.canClearedDropdown && this.componentParams.filterable
        },
        clearable() {
            return this.canClearedDropdown && this.componentParams.clearable
        },
        startObject() {
            if(this.startObjectIdFromQuery == this.getMyPosition && this.getMyPosition ){
                return this.myPosition
            }
            return this.startObjectIdFromQuery && this.getDenormalisedObjectById(this.startObjectIdFromQuery) ||
                this.destinationClosetEntranceId && this.getDenormalisedObjectById(this.destinationClosetEntranceId);
        },
        myPosition() {
            if(this.getMyPosition) {
                const positonData = cloneDeep(this.getDenormalisedObjectById(Number(this.getMyPosition)))
                positonData.name = this.$t('ui.guide.my-position', {name: this.t(positonData, 'name', 'Not set')})
                return positonData
            }
            return {}
        },
        destinationClosetEntranceId(){
            if(!this.isComponentParamsHasDestinationProps) {
                // this is fallback to save logic for old version or other map
                return this.getObjectClosestEntranceId(this.destinationObject);
            } else if(this.isComponentParamsHasDestinationProps && this.isShowDestinationClosetEntrance) {
                // if we can, we want to take ClosestEntrance from destinationObject
                if(
                    this.destinationObject?.meta?.closest_entrance 
                    || this.destinationObject?.meta?.use_default_entrance
                ) {
                    return this.getObjectClosestEntranceId(this.destinationObject)
                } else {
                    return null
                }
                //
            } else if(this.isComponentParamsHasDestinationProps && !this.isShowDestinationClosetEntrance) {
                // if we don't want show ClosestEntrance in all cases
                return null
            }
            return this.getObjectClosestEntranceId(this.destinationObject);
        },
        destinationClosetEntrance(){
            return this.getDenormalisedObjectById(this.destinationClosetEntranceId);
        },
        startObjectDestinationClosetEntranceId(){
            return this.getDenormalisedObjectById(this.startObjectDestinationClosetEntranceId);
        },
        destinationObjectIdFromQuery(){
            return Number(this.$route.query.t || this.$route.query.mTo);
        },
        destinationObject() {
            return this.getDenormalisedObjectById(this.destinationObjectIdFromQuery) || { id: '' };
        },
        startItemsTypes() {
            const configurableTypes = this.componentParams.start_items_types || [];
            return _.uniq([ 'current_position', 'start_object', ...configurableTypes ]);
        },
        startItems(){
            if(this.dropdownType) {
                const preparedItems =  [
                    ...(this.startObject && this.checkStartObjectType ? [this.startObject] : []),
                    ...this[DESTINATION_NAMES[this.dropdownType]]
                ]
                    .flat()
                    .map( o => ({name: this.t(o, 'name', 'Not set'), ...o }))
                    .filter(object => {
                        if(this.isFiltredByCatalogueShow) {
                            return this.t(object, 'show_in_catalogue') && object.id
                        }

                        return object.id
                    })
                
                return uniqBy(preparedItems, 'id')
            }
            const preparedItems = [
                ...(this.myPosition.name ? [this.startObject] : []),
                ...(this.startObject ? [this.startObject] : []),
                ...(this.destinationClosetEntrance?.id ? [this.destinationClosetEntrance] : []),
                ...this.startItemsTypes
                    .filter(t => t !== 'start_object')
                    .map(t => this[DESTINATION_NAMES[t]])
                    .flat()
            ]
                .map( o => ({name: this.t(o, 'name', 'Not set'), ...o }))
                .filter(object => {
                    if(this.isFiltredByCatalogueShow) {
                        return this.t(object, 'show_in_catalogue') && object.id
                    }

                    return object.id
                })
                
            return uniqBy(preparedItems, 'id')
        },
        componentParams() {
            return this.getMapConfigProp('components.OStartItemsDropdown.params') || {};
        },
        /**
         * if true we filtred object by parameter - show_in_catalogue
         * @default {false}
         */
        isFiltredByCatalogueShow() {
            return this.componentParams.is_filtred_by_catalogue_show
        },
        canClearedDropdown() {
            if(!this.dropdownType) return true
            return this.clearedTypesOfDropdown?.includes(this.dropdownType)
        },
        clearedTypesOfDropdown() {
            return this.componentParams.cleared_dropdown_types || ['tenants']
        },
        checkStartObjectType() {
            if(this.dropdownType == 'tenants' && this.startObject?.type == 'tenant') return true
            if(this.dropdownType == 'entrances' && (this.startObject?.type == 'entrance' || this.startObject?.type == 'portal')) return true
            return false
        },
        isComponentParamsHasDestinationProps() {
            return this.componentParams.hasOwnProperty('should_show_destination_closet_entrance')
        },
        isShowDestinationClosetEntrance() {
            return this.componentParams.should_show_destination_closet_entrance;
        }
    },
    methods: {
        onChangeStart(data) {
            this.$emit('onChangeStart', data)
        },
        onOpenChange() {
            this.isSelectOpen = !this.isSelectOpen
        },
        clearSelect() {
            this.$refs.oDropdown.clearSelect()
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
